import { c as _c } from "react/compiler-runtime";
import { cn } from '@/frontend/utils';
type DrizzleORMProps = React.SVGProps<SVGSVGElement> & {
  size?: string | number;
};
export function Drizzle(t0) {
  const $ = _c(11);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const sizeClass = size ? `size-${size}` : "size-12";
  let t1;
  if ($[4] !== className || $[5] !== sizeClass) {
    t1 = cn(sizeClass, className);
    $[4] = className;
    $[5] = sizeClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M6.13 10.67c.42.24.57.77.33 1.19l-2.82 4.92c-.24.42-.78.57-1.2.33a.87.87 0 0 1-.33-1.19L4.93 11c.24-.42.78-.57 1.2-.33M12.21 6.9c.42.24.57.77.33 1.19l-2.82 4.92c-.24.42-.78.57-1.2.33a.87.87 0 0 1-.33-1.19l2.82-4.92c.24-.42.78-.57 1.2-.33M21.56 6.9c.42.24.57.77.33 1.19l-2.82 4.92c-.24.42-.78.57-1.2.33a.87.87 0 0 1-.33-1.19l2.82-4.92c.24-.42.78-.57 1.2-.33M15.48 10.67c.42.24.57.77.33 1.19l-2.82 4.92c-.24.42-.78.57-1.2.33a.87.87 0 0 1-.33-1.19L14.28 11c.24-.42.78-.57 1.2-.33" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1) {
    t3 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className={t1} {...props}>{t2}</svg>;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}